import React, { useMemo, useState, useEffect } from "react"

//import components
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Button,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
} from "reactstrap"
import {
  FaEdit,
  FaStreetView,
  FaTelegramPlane,
  FaRegPaperPlane,
} from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchPvsSubcategory } from "../../../redux/actions/pvs"

const PvsSubCategory = () => {
  document.title = "PVS Subcategory List | PULA"

  const history = useNavigate()
  const dispatch = useDispatch()

  const pvsState = useSelector(state => state.pvs)
  const fetchPvsSubcategoryState = useSelector(
    state => state.screens.pvs.fetchPvsSubcategory
  )

  const [subcategoryData, setSubcategoryData] = useState([])
  const columns = useMemo(
    () => [
      {
        header: "Subcategory",
        accessorKey: "subcategory",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Slug",
        accessorKey: "slug",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Parent Category",
        accessorKey: "created_modified_at",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Count",
        accessorKey: "count",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() =>
                  history(`/edit-pvs-subcategory/${row.enc_pvs_subcat_id}`)
                }
                title="Edit PVS"
              >
                <FaEdit />
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchPvsSubcategory())
  }, [dispatch])

  useEffect(() => {
    if (pvsState && Array.isArray(pvsState.subcategoryList)) {
      setSubcategoryData(pvsState.subcategoryList)
    }
  }, [pvsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-0 nom-title">PVS Subcategory List</h4>
          </div>
          <Button
            color="primary"
            onClick={() => history("/add-pvs-subcategory")}
          >
            Add PVS Subcategory
          </Button>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={subcategoryData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          buttonClass="btn primary-button"
          // isAddButton={true}
          buttonName="Add PVS Subcategory"
          // handleUserClick={() => {
          //   history("/add-pvs-subcategory")
          // }}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass=" table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
          noDataMessage={fetchPvsSubcategoryState.message}
        />
      </div>
    </div>
  )
}

export default PvsSubCategory
